(function() {
  define('bazemont/ad/form',['angular'], function() {
    'use strict';
    return angular.module('bazemontAdForm', []).component('bazemontAdForm', {
      templateUrl: '/assets/javascripts/bazemont/ad/form.html',
      bindings: {
        id: '@',
        contentMaxLength: '@',
        nbMaxPictures: '@'
      },
      controller: [
        '$window', 'Ad', 'TlhNotificationService', function($window, Ad, TlhNotificationService) {
          var preselectAdCategory, vm;
          vm = this;
          vm.$onInit = function() {
            vm.submitting = false;
            return Ad.get({
              id: vm.id
            }, function(result) {
              vm.ad = result.ad;
              vm.categories = result.categories;
              return preselectAdCategory();
            });
          };
          vm.getContentCharCounter = function() {
            var length;
            length = vm.ad && vm.ad.content ? vm.ad.content.length : 0;
            return vm.contentMaxLength - length;
          };
          vm.submit = function() {
            if (vm.form.$valid && !vm.submitting) {
              TlhNotificationService.info({
                message: 'Enregistrement en cours...',
                delay: false
              });
              vm.submitting = true;
              return new Ad(vm.ad).$save().then(function(response) {
                TlhNotificationService.success({
                  message: 'Enregistrement terminé',
                  replaceMessage: true
                });
                return $window.location.href = response.url;
              })["catch"](function(error) {
                var message;
                console.error(error);
                message = "L'enregistrement a échoué :<br>";
                message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
                return TlhNotificationService.error({
                  message: message,
                  replaceMessage: true,
                  delay: false
                });
              })["finally"](function() {
                return vm.submitting = false;
              });
            }
          };
          vm.cancel = function() {
            return $window.history.back();
          };
          preselectAdCategory = function() {
            var category, _i, _len, _ref, _results;
            if (vm.ad && vm.ad.category) {
              _ref = vm.categories;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                category = _ref[_i];
                if (category.id === vm.ad.category.id) {
                  vm.ad.category = category;
                  break;
                } else {
                  _results.push(void 0);
                }
              }
              return _results;
            }
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=form.js.map
;
